// extracted by mini-css-extract-plugin
module.exports = {"container":"ResetPasswordForm_container__1M6oS"};